import classes from './SuggestionChip.module.scss'

export type SuggestionChipProps = Readonly<{
  label: string
  onClick: () => void
  disabled?: boolean
  testId?: string
}>

/**
 * A pill-shaped, clickable suggestion prompt. Generic: neither the Lemonade filter
 * `Chip` (small radius, close icon) nor app-specific chips match this neutral pill,
 * so the ai-chat lib owns it.
 */
export function SuggestionChip({
  label,
  onClick,
  disabled = false,
  testId,
}: SuggestionChipProps) {
  return (
    <button
      type="button"
      className={classes.chip}
      onClick={onClick}
      disabled={disabled}
      data-testid={testId}
    >
      {label}
    </button>
  )
}
